import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getUserData = async (userId) => {
  const token = sessionStorage.getItem('authToken');
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/user`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to get user');
    }

    return response.json();
  } catch (error) {
    console.error('Error getting user:', error);
    throw error;
  }
};

export const getUserImg = async (userId) => {
  const token = sessionStorage.getItem('authToken');
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/userImg`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to get user profile picture');
    }

    return response.json();
  } catch (error) {
    console.error('Error getting user profile picture:', error);
    throw error;
  }
};
